<template>
  <v-container fluid class="fill-height">
    <v-card
      :class="'fill-height idcs-fill-width idcs-main-list back-img-'+(task.status==1||task.status==2?'send':'stat')"
    >
      <v-card-title>
        <v-chip class="mr-4" :color="statcol">{{$t("status._"+task.status)}}</v-chip>
        <span class="mr-4" v-if="task.planed && task.status==2">{{task.name+(task.planed?",":"")}}</span>
        <span class="mr-4" v-if="task.planed && task.status==2">
          <span class="mr-2">{{$t("label.sendat")}}</span>
          <span>{{task.planed|dt-time}}</span>
        </span>

        <v-spacer></v-spacer>
        <v-btn icon :to="goto()" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <div class="subtitle-2">{{$t("fields.sender")}}</div>
            <div class="font-weight-black">
              <span>{{$store.getters["user/sender"]}}</span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="subtitle-2">{{$t("fields.list")}}</div>
            <div class="font-weight-black">
              <span>{{task.list}}</span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="subtitle-2">{{$t("fields.created")}}</div>
            <div class="font-weight-black">
              <span>{{task.created|dt-time}}</span>
            </div>
          </v-col>
          <v-col cols="3">
            <div class="subtitle-2">{{$t("fields.updated")}}</div>
            <div class="font-weight-black">
              <span>{{task.updated|dt-time}}</span>
            </div>
          </v-col>
          <v-col cols="12" v-if="task.completed>1">
            <div class="subtitle-2">{{$t("fields.lastError")}}</div>
            <div class="font-weight-black">
              <span class="error--text">{{$t("complete._"+task.completed)}}</span>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="subtitle-2">{{$t("fields.message")}}</div>
            <div class="font-weight-black">
              <span>{{task.message}}</span>
            </div>
          </v-col>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <v-data-table
            class="fill-height idcs-fill-width idcs-main-list transparent"
            :headers="headers"
            :items="members"
            :footer-props="foot_props"
            :no-data-text="$t('label.nodata')"
          >
            <template v-slot:item.state="{item}">
              <v-icon :color="testMessage(item)?'success':'error'">mdi-circle</v-icon>
            </template>
            <template v-slot:item.number="{item}">{{item.number|phone}}</template>
            <template v-slot:item.sended="{item}">{{item.sended|dt-time}}</template>
            <template v-slot:item.price="{item}">{{item.price|currency4}}</template>
            <template v-slot:item.rprice="{item}">{{item.rprice|currency4}}</template>
            <template v-slot:item.cprice="{item}">{{item.cprice|currency4}}</template>
            <template v-slot:item.unicode="{item}">
              <v-icon v-if="item.unicode" color="green">mdi-check</v-icon>
            </template>
            <template v-slot:body.append="{headers}">
              <tr>
                <td :colspan="headers.length-2"></td>
                <td align="center">{{task.msgcount}}</td>
                <td align="right" class="title">{{task.price | currency}}</td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="isVisible('edit')"
          rounded
          outlined
          color="blue"
          @click="d_edit=true"
        >{{$t("button.edittask")}}</v-btn>
        <v-btn
          v-if="isVisible('resend')"
          rounded
          outlined
          color="blue"
          @click="resend"
        >{{$t("button.resend")}}</v-btn>
        <v-btn
          v-if="isVisible('delete')"
          rounded
          outlined
          color="blue"
          @click="dmode='delete',d_confirm=true"
        >{{$t("button.delete")}}</v-btn>
        <v-btn
          v-if="isVisible('archive')"
          rounded
          outlined
          color="blue"
          @click="dmode='archive',d_confirm=true"
        >{{$t("button.archive")}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="isVisible('reset')"
          outlined
          rounded
          color="error"
          @click="dmode='reset',d_confirm=true"
        >
          <v-icon class="mr-2">mdi-close</v-icon>
          {{$t("button.reset")}}
        </v-btn>
        <v-btn
          v-if="isVisible('stop')"
          outlined
          rounded
          color="error"
          @click="dmode='stop',d_confirm=true"
        >
          <v-icon class="mr-2">mdi-close</v-icon>
          {{$t("button.stop")}}
        </v-btn>
        <v-btn
          v-if="isVisible('schedule') && task.price"
          rounded
          large
          color="success"
          @click="d_schedule=true"
        >
          <v-icon class="mr-2">mdi-alarm-plus</v-icon>
          {{$t("button.schedule")}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmDialog v-model="d_confirm" :mode="dmode" @click:ok="confirmed" />
    <v-dialog v-model="d_schedule" persistent width="800px">
      <v-card>
        <v-card-title class="idcs-dialog-title">
          <span>{{$t("dialog.plane")}}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="d_schedule=false" color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row class="text-center">
              <v-col cols="12">
                <v-btn
                  rounded
                  outlined
                  dark
                  color="blue"
                  large
                  @click="clearTime(),dmode='start',confirmed()"
                >
                  <v-icon large class="mr-2">mdi-numeric-1-circle</v-icon>
                  {{$t('button.now')}}
                  <v-icon class="ml-2">mdi-send</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">{{$t('label.select_date')}}</v-col>
              <v-col>
                <v-date-picker v-model="start.date" no-title :min="$moment().format('YYYY-MM-DD')"></v-date-picker>
              </v-col>
              <v-col>
                <v-time-picker
                  ref="startTime"
                  v-model="start.time"
                  format="24hr"
                  no-title
                  scrollable
                ></v-time-picker>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="startTime"
                  readonly
                  clearable
                  :label="$t('fields.start.lbl')"
                  :placeholder="$t('fields.start.ph')"
                  @click:clear="clearTime"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  rounded
                  outlined
                  large
                  dark
                  color="blue"
                  @click="dmode='start',confirmed('start')"
                >
                  <v-icon large class="mr-2">mdi-numeric-2-circle</v-icon>
                  {{$t('button.setdate')}}
                  <v-icon class="ml-2">mdi-send-clock</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_edit" persistent width="600">
      <v-card rounded shaped>
        <v-card-title class="idcs-dialog-title">
          <i18n path="dialog.editmsg" />
          <v-spacer></v-spacer>
          <v-btn icon @click="d_edit=false" color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form1">
            <v-text-field
              v-model="task.name"
              :rules="[v=>!!v||$t('error.required')]"
              :label="$t('fields.name')"
            ></v-text-field>
            <div>{{$t("label.params")}}</div>
            <v-chip v-for="k in params" :key="k" color="primary lighten-2" class="mr-1">
              <v-icon class="mr-1" @click="insertAtCaret(k)">mdi-plus-circle</v-icon>
              <span>{{k.substr(1)}}</span>
              <v-icon class="ml-1" @click="removeParam(k)">mdi-minus-circle</v-icon>
            </v-chip>
            <v-text-field
              ref="ref_text_sms"
              class="mt-4"
              v-model="task.message"
              :rules="[v=>!!v||$t('error.required')]"
              :label="$t('fields.message')"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="calculate" color="primary">{{$t("button.apply")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { addTarifData } from "@/msgService.js";
import commonmixin from "@/mixins/commonlist.js";
// eslint-disable-next-line
const unicodetest = /[^\u0000-\u00ff]/;
const phonetest = /^['+']?(371)?\d{8,11}$/i;

export default {
  name: "Task",
  mixins: [commonmixin],
  data() {
    return {
      start: {
        date: null,
        time: null,
      },
      d_schedule: false,
      d_edit: false,
      task1: {
        message: "",
        status: 1,
        recipients: {
          items: [],
        },
      },
      // totals: {
      //   count: 0,
      //   price: 0
      // },
      headMain: [
        {
          text: this.$t("fields.state"),
          value: "state",
        },
        {
          text: this.$t("fields.recipient"),
          value: "number",
        },
        {
          text: this.$t("fields.message"),
          value: "text",
        },
        {
          text: this.$t("fields.size"),
          value: "len",
          align: "center",
        },
        {
          text: this.$t("fields.isutf"),
          value: "unicode",
          align: "center",
        },
        {
          text: this.$t("fields.count"),
          value: "count",
          align: "center",
        },
        {
          text: this.$t("fields.msgprice"),
          value: "price",
          align: "right",
        },
      ],
      headEnded: [
        {
          text: this.$t("fields.recipient"),
          value: "number",
        },
        {
          text: this.$t("fields.message"),
          value: "text",
        },
        {
          text: this.$t("fields.sended"),
          value: "sended",
          align: "center",
        },
        {
          text: this.$t("fields.respcode"),
          value: "responseCode",
          align: "center",
        },
        {
          text: this.$t("fields.cparts"),
          value: "cparts",
          align: "center",
        },
        {
          text: this.$t("fields.cprice"),
          value: "cprice",
          align: "right",
        },
      ],
      headFinance: [
        {
          text: this.$t("fields.recipient"),
          value: "number",
        },
        {
          text: this.$t("fields.sended"),
          value: "sended",
          align: "center",
        },
        {
          text: this.$t("fields.respcode"),
          value: "responseCode",
          align: "center",
        },
        {
          text: this.$t("fields.cparts"),
          value: "cparts",
          align: "center",
        },
        {
          text: this.$t("fields.cprice"),
          value: "cprice",
          align: "right",
        },
      ],
      headEndedAdmin: [
        {
          text: this.$t("fields.recipient"),
          value: "number",
        },
        {
          text: this.$t("fields.message"),
          value: "text",
        },
        {
          text: this.$t("fields.sended"),
          value: "sended",
          align: "center",
        },
        {
          text: this.$t("fields.respcode"),
          value: "responseCode",
          align: "center",
        },
        {
          text: this.$t("fields.respdesc"),
          value: "responseText",
          align: "center",
        },
        {
          text: this.$t("fields.rparts"),
          value: "rparts",
          align: "center",
        },
        {
          text: this.$t("fields.rprice"),
          value: "rprice",
          align: "right",
        },
        {
          text: this.$t("fields.country"),
          value: "country",
          align: "center",
        },
        {
          text: this.$t("fields.provider"),
          value: "provider",
          align: "center",
        },
        {
          text: this.$t("fields.cparts"),
          value: "cparts",
          align: "center",
        },
        {
          text: this.$t("fields.cprice"),
          value: "cprice",
          align: "right",
          width: 100,
        },
      ],
    };
  },
  computed: {
    members() {
      return this.task1.recipients.items;
    },
    statcol() {
      if (this.task.status == 1) return "warning";
      if (this.task.status == 2) return "success";
      if (this.task.status == 4) return "error";
      if (this.task.status == 5) return "accent";
      return "info";
    },
    task() {
      return this.task1;
    },
    headers() {
      switch (this.$route.name) {
        case "task-history":
          if (this.$store.getters["user/isAdmin"]) return this.headEndedAdmin;
          else return this.headEnded;
        case "task-finance":
          return this.headFinance;
        default:
          return this.headMain;
      }
    },
    startTime: {
      get() {
        return this.buildStartDate().format("YYYY-MM-DD HH:mm");
      },
      set() {},
    },
    params() {
      let p = [];
      try {
        for (var k in this.task.recipients.items[0]) {
          if (k[0] != "$") continue;
          p.push(k);
        }
      } catch (error) {
        console.log(error);
      }
      return p;
    },
  },
  mounted() {
    this.$api.getTask(this.$route.params.id).then((response) => {
      this.task1 = response;
      // this.totals.count = 0;
      // this.totals.price = 0;
      if (this.task1.status != 5 && this.task1.status != 6)
        addTarifData(this.task1, this.$store.getters["user/tarif"], false);
    });
  },
  methods: {
    goto() {
      switch (this.$route.name) {
        case "task-history":
          return "/history";
        case "task-finance":
          return "/finance";
        default:
          return "/scheduler";
      }
    },
    testMessage(i) {
      return phonetest.test(i.number) && i.count && i.price;
    },
    // broken, IDLE, SCHEDULED, STARTED, PAUSED, STOPPED, ARCHIVED;
    isVisible(mode) {
      switch (mode) {
        case "reset":
          return this.task.status == 2;
        case "stop":
          return this.task.status == 3;
        case "resend":
        case "archive":
          return this.task.status == 5;
        case "delete":
        case "schedule":
        case "edit":
          return this.task.status == 1 || this.task.status == 4;
        default:
      }
      return false;
    },
    removeParam(k) {
      this.task.message = this.task.message.split("{" + k + "}").join("");
    },
    calculate() {
      if (!this.$refs.form1.validate()) return;
      addTarifData(this.task1, this.$store.getters["user/tarif"], true);
      this.$api
        .updateTask(this.$route.params.id, {
          type_: this.task.type,
          name_: this.task.name,
          message_tpl: this.task.message,
          recipients: this.task.recipients,
        })
        .then(() => {
          this.d_edit = false;
        });
    },
    buildStartDate() {
      if (this.start.date == null) {
        this.start.date = this.$moment().format("YYYY-MM-DD");
      }
      if (this.start.time == null) {
        this.start.time = this.$moment().add(59, "second").format("HH:mm");
      }
      return this.$moment(this.start.date + " " + this.start.time);
    },
    clearTime() {
      this.start.time = null;
      this.start.date = null;
      if (this.$refs.startTime) this.$refs.startTime.selectingHour = true;
    },
    resend() {
      this.$api.resendTask(this.$route.params.id).then((response) => {
        if (response) this.$router.push({ name: "scheduler" });
      });
    },
    confirmed() {
      let target = [];
      switch (this.dmode) {
        case "start":
          if (!this.$refs.form.validate()) return;
          this.task.recipients.items.forEach((e) => {
            let elem = {
              number: e.number,
              text: e.text,
              count: e.count,
              price: e.price,
            };
            Object.keys(e).forEach((k) => {
              if (k[0] != "$") return;
              elem[k] = e[k];
            });
            target.push(elem);
          });
          this.$api
            .startTask(this.$route.params.id, {
              type_: this.task.type,
              message_tpl: this.task.message,
              recipients: { items: target },
              name_: this.task.name,
              at: this.start.date?this.buildStartDate().valueOf():null,
            })
            .then((response) => {
              if (response) this.$router.push({ name: "scheduler" });
            })
            .catch((error) => {
              if (error.message.indexOf("status code 15001") != -1) {
                this.$root.$emit("showmsg", { msg: this.$t("error.nomoney") });
              } else {
                console.log(error);
              }
            });
          break;
        case "reset":
          this.$api.resetTask(this.$route.params.id).then((response) => {
            if (response) this.$router.push({ name: "scheduler" });
          });
          break;
        case "stop":
          this.$api.stopTask(this.$route.params.id).then((response) => {
            if (response) this.$router.push({ name: "scheduler" });
          });
          break;
        case "archive":
          this.$api.archiveTask(this.$route.params.id).then((response) => {
            if (response) this.$router.push({ name: "history" });
          });
          break;
        case "delete":
          this.$api.deleteTask(this.$route.params.id).then((response) => {
            if (response) this.$router.push({ name: "scheduler" });
          });
          break;
        default:
      }
    },
    insertAtCaret(k) {
      const el = this.$refs.ref_text_sms.$el.querySelector("input");
      let cursorPos = el.selectionEnd;
      this.task.message =
        this.task.message.substring(0, cursorPos) +
        "{" +
        k +
        "}" +
        this.task.message.substring(cursorPos);
      cursorPos += this.task.message.length;
      this.$nextTick(() => el.setSelectionRange(cursorPos, cursorPos));
    },
  },
};
</script>

<style scoped>
.back-img-send {
  background-image: url("../../public/img/sms_send_group.svg");
  background-position: bottom;
  background-size: cover;
}
.back-img-stat {
  background-image: url("../../public/img/sms_group.svg");
  background-position: bottom;
  background-size: cover;
}
</style>